var GenericView = require('views/generic.view.ts');
var Handlebars = require('handlebars');
var Template = require('text-loader!../../templates/results/economical_technical.results.template.html');
var Handlebars = require('../../../libs/handlebars/handlebars-v4.0.5.js');

var ExhaustiveAnalysisView = require('views/results/exhaustive_analysis.results.view.ts');
var MaximizesNpvView = require('views/results/maximizes_npv.results.view.ts');
var MaximizesSelfSufficiencyView = require('views/results/maximizes_self-sufficiency.results.view.ts');
var CostEffectiveView = require('views/results/cost_effective.results.view.ts');

var TheView = GenericView.extend({
    el: '#tab1',
    tagName: '',
	template: Handlebars.compile(Template),
	data: null,
	months: [{number:1, name: 'January'}, {number:2, name: 'February'}, {number:3, name: 'March'}, {number:4, name: 'April'}, {number:5, name: 'May'}, {number:6, name: 'June'}, {number:7, name: 'July'}, {number:8, name: 'August'}, {number:9, name: 'September'}, {number:10, name: 'October'}, {number:11, name: 'November'}, {number:12, name: 'December'}],
	initialize: function (options) {
        this.data = options.data;
        this.render();
    },
    superRender: GenericView.prototype.render,
    render: function () {
        this.superRender();
        this.$el.html(this.template({data: this.data, months: this.months}));

        var analysis_method = $("input[name='analysis_method']:checked").val();
        if ( analysis_method == "EXHAUSTIVE_ANALYSIS" ) {
            var exhaustive_analysis_view = new ExhaustiveAnalysisView({"data": this.data});
            $("#exhaustiveResults").show();
        } else if ( analysis_method == "MAXIMIZE_NPV" ) {
            var maximizes_npv_view = new MaximizesNpvView({"data": this.data});
            $("#npv").show();
        } else if ( analysis_method == "MAXIMIZE_SSR" ) {
            var maximizes_self_view = new MaximizesSelfSufficiencyView({"data": this.data});
            $("#selfSufficiency").show();
        } else if ( analysis_method == "INCREASED_SSR_NPV" ) {
            var cost_effective_view = new CostEffectiveView({"data": this.data});
            $("#costEffective").show();
        }

    },
    events: {

    },
});

module.exports= TheView;